import 'bootstrap/dist/css/bootstrap.min.css'; 

const Header = () => {
  return (
            // to be sticky added, position: 'sticky', top: 0, zIndex: '1000'
    <div className="container-fluid" style={{ backgroundColor: '#4DA34C', padding: '0', position: 'sticky', top: 0, zIndex: '1000' }}>
      {/* Navbar with dropdowns for HOME, ABOUT, NEWS aligned to the right */}
      <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#4DA34C;', padding: '0' }}>
        <div className="d-flex justify-content-between w-100">
          {/* Logo on the left side */}
          <a href="https://pgparks.com" style={{ marginLeft: '0' }}>
            <img
              src={`${process.env.PUBLIC_URL}/image/dept_logo.png`}
              alt="PGParks Header"
              style={{ height: '90px', overflow: 'hidden', display: 'block' }}
            />
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Header;
